import React, { useState, useEffect } from "react";
import Close from "../../../../Icons/Close";
import { styles } from "../../../../ReactConst";
import { StyleRoot } from "radium";
export default function ModalDeleteFermeture(props) {
  const [styleFadeIn, setFadeIn] = useState(true);

  const closeModaleCancel = React.useCallback(() => {
    setFadeIn(false);
    setTimeout(() => {
      props.handleCloseFermeture();
    }, 400);
  }, []);
  return (
    <StyleRoot>
      <div
        class="modal show modal-skin"
        style={styleFadeIn === true ? styles.bounce : styles.bounce2}
        id="modalConfirm"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                props.onSubmitSuppression();
              }}
            >
              <button
                onClick={closeModaleCancel}
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <Close src="img/close.svg" class="img-fluid" alt="" />
              </button>
              <div className="modal-body">
                <section>
                  <h5 className="modal-title">Supprimer une fermeture</h5>
                </section>
                <section>
                  <h5>Souhaitez-vous supprimer cette date de fermeture?</h5>
                </section>
                <p className="bottom-space"></p>
                <section>
                  <div className="d-flex justify-content-center">
                    <button
                      type="submit"
                      className="btn-gradient btn-valid margin-left col-md-6 col-lg-6"
                      style={{ background: "grey", float: "right" }}
                    >
                      {" "}
                      Supprimer
                    </button>
                  </div>
                </section>
              </div>
            </form>
          </div>
        </div>
      </div>
    </StyleRoot>
  );
}
